import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    HStack,
} from '@chakra-ui/react';
import type { NexReconciliationIdentifierMode } from '../../utils/invoiceNexIdentifierUi';
import { getInvoiceNexIdentifierUi } from '../../utils/invoiceNexIdentifierUi';

export interface InvoiceRoChangeConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
    previousRo: string;
    nextRo: string;
    onConfirm: () => void;
    nexReconciliationIdentifierMode?: NexReconciliationIdentifierMode;
}

const InvoiceRoChangeConfirmModal = ({
    isOpen,
    onClose,
    isLoading,
    previousRo,
    nextRo,
    onConfirm,
    nexReconciliationIdentifierMode = 'ro',
}: InvoiceRoChangeConfirmModalProps) => {
    const idUi = getInvoiceNexIdentifierUi(nexReconciliationIdentifierMode);
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900">
                    {idUi.saveIdentifierChangeModalTitle}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="md" color="gray.700" mb={3}>
                        {idUi.saveIdentifierChangeLeadIn} <strong>{previousRo || 'empty'}</strong> to{' '}
                        <strong>{nextRo || 'empty'}</strong>.
                    </Text>
                    <Text fontSize="md" color="gray.600">
                        {idUi.saveIdentifierChangeNexRefreshBody}
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={3}>
                        <Button size="action" variant="outlineGray" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button size="action"
                            bg="#0071E3"
                            color="white"
                            _hover={{ bg: '#3544a0' }} onClick={onConfirm} isLoading={isLoading} loadingText="Saving...">
                            Save and refresh NEX
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InvoiceRoChangeConfirmModal;
